// esc押した時の実行優先度
const escPrimaries = {
  globalPopup: 100,
  palettePopup: 95,
  imageDetailEditorPopup: 90,
  imagePreview: 90,
  htmlPreview: 90,
  linkChecker: 90,
  chipsPopup: 90,
  imageUploadPopup: 90,
  imageManagerPopup: 80,
  editorCloseButton: 50,
  editorHeaderCloseButton: 10,
}

export default {
  mounted () {
    document.addEventListener('keydown', this.mixinEscShortcut)
    document.addEventListener('keydown', this.mixinCtrlSShortcut)

    // HTMLプレビューなどのiframe対応
    document.querySelectorAll('iframe').forEach(iframe => {
      iframe.addEventListener('load', () => {
        iframe.contentWindow.document.addEventListener('keydown', this.mixinEscShortcut)
        iframe.contentWindow.document.addEventListener('keydown', this.mixinCtrlSShortcut)
      })
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.mixinEscShortcut)
    document.removeEventListener('keydown', this.mixinCtrlSShortcut)

    // HTMLプレビューなどのiframe対応
    document.querySelectorAll('iframe').forEach(iframe => {
      iframe.addEventListener('load', () => {
        iframe.contentWindow.document.removeEventListener('keydown', this.mixinEscShortcut)
        iframe.contentWindow.document.removeEventListener('keydown', this.mixinCtrlSShortcut)
      })
    })
  },
  computed: {
    mixinIsMac () {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0
    }
  },
  methods: {
    mixinEscShortcut (event) {
      if (event.key === 'Escape') {
        const targetEl = this.$el.querySelector('[data-shortcut-esc]')
        const activeEls = Array.from(document.querySelectorAll('[data-shortcut-esc]'))
        let primaryEl = null
        activeEls.forEach(el => {
          if (!primaryEl || escPrimaries[el.dataset.shortcutEsc] > escPrimaries[primaryEl.dataset.shortcutEsc]) {
            primaryEl = el
          }
        })
        const isPrimaryEl = primaryEl.isEqualNode(targetEl)
        if (isPrimaryEl) {
          targetEl.click()
        }
      }
    },
    mixinCtrlSShortcut (event) {
      if (
        ((this.mixinIsMac && !event.ctrlKey && event.metaKey) || (!this.mixinIsMac && event.ctrlKey && !event.metaKey)) &&
        String.fromCharCode(event.which).toLowerCase() === 's'
      ) {
        event.preventDefault() // ブラウザのHTML保存ショートカットを機能させないように
        const targetEl = this.$el.querySelector('[data-shortcut-ctl-s]')
        if (targetEl) {
          targetEl.click()
        }
      }
    },
  }
}
